// test2266
(2266 && 0);
